import gql from 'nanographql';
import Agent from "./Agent";

export default class WaitingListAgent extends Agent {

    async joinWaitingList(data) {
        if (!data.scheduleId || !data.date) {
            return {};
        }

        const query = gql`
                mutation JoinWaitingList($scheduleId: ID!, $date: DateTime!, $quantity: Int!, $email: String, $firstName: String, $lastName: String) {
                    joinWaitingList(scheduleId: $scheduleId, date: $date, quantity: $quantity, email: $email, firstName: $firstName, lastName: $lastName) {
                        success
                        errorCode
                        existingQuantity
                        proposedTotal
                    }
                }`;

        return this.send(query, {
            scheduleId: data.scheduleId,
            date: data.date,
            quantity: parseInt(data.quantity),
            email: data.email || null,
            firstName: data.firstName || null,
            lastName: data.lastName || null
        }, "joinWaitingList");
    }

    async incrementWaitingList(data) {
        if (!data.scheduleId || !data.date) {
            return {};
        }

        const query = gql`
                mutation IncrementWaitingList($scheduleId: ID!, $date: DateTime!, $additionalQuantity: Int!, $email: String) {
                    incrementWaitingList(scheduleId: $scheduleId, date: $date, additionalQuantity: $additionalQuantity, email: $email) {
                        success
                        errorCode
                        existingQuantity
                        proposedTotal
                    }
                }`;

        return this.send(query, {
            scheduleId: data.scheduleId,
            date: data.date,
            additionalQuantity: parseInt(data.additionalQuantity),
            email: data.email || null
        }, "incrementWaitingList");
    }

    async getMyEntries() {
        const query = gql`
                query {
                    myWaitingListEntries {
                        id
                        activityName
                        schedule {
                            id
                            from
                            to
                            utcOffset
                        }
                        date
                        quantity
                    }
                }`;

        return this.send(query, {}, "myWaitingListEntries", { skipToken: true });
    }

}
